import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { LOCALES } from './locales';

use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		backend: {
			loadPath: (lng: string) => `/locales/${lng}/translation.json?v=${process.env.REACT_APP_VERSION}`,
		},

		// interpolation: {
		// 	escapeValue: false,
		// },
		detection: {
			cookieMinutes: 60 * 24 * 365,
			cookieOptions: {
				maxAge: 60 * 60 * 24 * 365,
				path: '/',
			},
			lookupCookie: 'i18next',
		},

		fallbackLng: 'en',
		load: 'languageOnly',
		supportedLngs: LOCALES,
	});

export { default } from 'i18next';
